import React from 'react';
import { ChipResellerProps, ChipFullContactInfoProps, ChipSearchResult } from '@barkinglabs/nano-shared';
import ContactModal, { searchResultToContactModalProps } from '../../modals/ContactModal/ContactModal';
import styles from '../../DetailsSharedStyles.module.scss';
import { DateTime } from 'luxon';
import InfoCard from '../../InfoCard/InfoCard';

export interface ResellerDetailsProps {
  reseller: ChipResellerProps;
  searchResult: ChipSearchResult;
}

const getFormattedAddress = (address: ChipFullContactInfoProps): React.ReactElement => {
  return (
    <span>
      {address.line1 && (
        <>
          {address.line1}
          <br />
        </>
      )}
      {address.city} {address.state} {address.zipcode}
    </span>
  );
};

const lastUpdated = (date: string) => {
  const dateTime = DateTime.fromISO(date);
  return dateTime.toFormat(`LLL. d, y`);
};

export default function ResellerDetails({ searchResult, reseller }: ResellerDetailsProps) {
  const { contactInfo, updatedAt } = reseller;

  return (
    <div className={styles.main}>
      <InfoCard
        rows={[
          [{ label: 'Org', value: reseller.name }],
          [{ label: 'Email', value: contactInfo.primaryEmail }],
          [{ label: 'Address', value: getFormattedAddress(contactInfo) }],
          [{ label: 'Phone', value: contactInfo.primaryPhone }],
          [{ label: 'Last updated', value: lastUpdated(updatedAt) }],
        ]}
      />
      <div className={styles.buttons}>
        <ContactModal
          {...searchResultToContactModalProps(searchResult)}
          contactTarget={{ kind: 'reseller' }}
          trigger={<button className="btn-black">Contact</button>}
        />
      </div>
    </div>
  );
}
